import { MEDIA_LIST } from '../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case MEDIA_LIST.LOAD:
      return {
        ...state,
        loading: true,
      };
    case MEDIA_LIST.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case MEDIA_LIST.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
